import axiosInstance from "@/api/axiosInstance";
import {
  ChangeFileAccessRequest,
  ChangeFileAccessResponse,
  ChangeFileAccessResponseData,
} from "./types";

export const changeFileAccess = async (
  fileUuid: string,
  makePublic: boolean,
): Promise<ChangeFileAccessResponseData> => {
  const response = await axiosInstance.put<ChangeFileAccessResponse>(
    `/api/private/file-management/files/${fileUuid}/access`,
    { makePublic } as ChangeFileAccessRequest,
  );

  return response.data.data; // Unwrap the data property
};
